import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';

const COLONAT = ':@:';

class AdapterSetting extends React.Component {

	state = {
		rootList: [{ name: '', path: '' }],
	};

	componentDidMount() {
		this.rootListToArray();
	}

	componentDidUpdate(prevProps) {
		const prev = prevProps.adapterSetting?.data || {};
		const curr = this.props.adapterSetting?.data || {};
		if (prev.rootName !== curr.rootName || prev.rootPath !== curr.rootPath) {
			this.rootListToArray();
		}
	}

	rootListToArray = () => {
		const data = this.props.adapterSetting?.data || {};
		const rawNames = (data.rootName || '');
		const rawPaths = (data.rootPath || '');

		const names = rawNames === '' ? [] : rawNames.split(COLONAT);
		const paths = rawPaths === '' ? [] : rawPaths.split(COLONAT);

		const len = Math.max(names.length || 1, paths.length || 1);
		const items = Array.from({ length: len }, (_, i) => ({
			name: names[i] || '',
			path: paths[i] || '',
		}));

		this.setState({ rootList: items });
	};

	syncItems = () => {
		const names = this.state.rootList.map(list => list.name).join(COLONAT);
		const paths = this.state.rootList.map(list => list.path).join(COLONAT);
		this.props.setRootName({ target: { value: names } });
		this.props.setRootPath({ target: { value: paths } });
	};

	addItem = () => {
		this.setState(
			prev => ({ rootList: [...prev.rootList, { name: '', path: '' }] }),
			this.syncItems
		);
	};

	deleteItem = (index) => {

		if (this.state.rootList.length === 1) {
			this.props.setErrorLabel({ rootPath: 'as.button.msg.min' });
			return;
		}
		this.setState(
			prev => {
				const next = prev.rootList.slice();
				next.splice(index, 1);
				return { rootList: next };
			},
			() => {
				this.props.setErrorLabel({});
				this.syncItems();
			}
		);
	};

	handleRootListChange = (index, field, value) => {
		const rootList = [...this.state.rootList];
		rootList[index][field] = value;
		this.setState({ rootList }, this.syncItems);
	};

	onClickSaveStorageName = (e) => {
		var errorLabel = {}

		if (isEmpty(this.props.adapterSetting.data.storageName)) {
			errorLabel = {
				storageName: "as.button.msg.save.blank"
			}
		} else {
			this.props.fetchAdapterSetStorage(this.props.adapterSetting.data.adapter, this.props.adapterSetting.data.storageName)
		}

		this.props.setErrorLabel(errorLabel)
	}

	onClickSaveParamsName = (e) => {
		var errorLabel = {}

		if (isEmpty(this.props.adapterSetting.data.paramsName)) {
			errorLabel = {
				paramsName: "as.button.msg.save.blank"
			}
		} else {
			this.props.fetchAdapterSetParams(this.props.adapterSetting.data.adapter, this.props.adapterSetting.data.paramsName)
		}

		this.props.setErrorLabel(errorLabel)
	}

	onClickSaveRootPath = (e) => {
		if (this.errorCheckRootPath()) {
			this.props.fetchAdapterSetRootPath(this.props.adapterSetting.data.adapter, this.props.adapterSetting.data.rootName, this.props.adapterSetting.data.rootPath)
		}
	}

	errorCheckRootPath = () => {
		var isCheck = true
		var errorLabel = {}
		const rootNameStr = (this.props.adapterSetting.data.rootName || '').trim();
		const rootPathStr = (this.props.adapterSetting.data.rootPath || '').trim();

		// 둘 다 빈 값일 때 => rootName 과 rootPath 가 빈 값으로 저장된다.
		if (rootNameStr === '' && rootPathStr === '') {
			this.props.setErrorLabel({});
			return true;
		}
		// rootName 은 빈 값인데, rootPath 에는 값이 있을 때 => 저장되지 못하게 함.
		if (rootNameStr === '' && rootPathStr !== '') {
			errorLabel = { rootPath: "as.button.msg.save.verify" };
			this.props.setErrorLabel(errorLabel);
			return false;
		}

		const rootName = rootNameStr.split(COLONAT);
		const rootPath = rootPathStr.split(COLONAT);


		if (rootName.length !== rootPath.length) {
			errorLabel = {
				rootPath: "as.button.msg.save.verify"
			}
			isCheck = false
		} else {
			for (var i in rootName) {
				const nameValue = rootName[i]?.trim();
				const pathValue = rootPath[i]?.trim();

				if (isEmpty(nameValue) && !isEmpty(pathValue)) {
					errorLabel = {
						rootPath: "as.button.msg.save.verify"
					}
					isCheck = false;
					break;
				}
			}
		}

		this.props.setErrorLabel(errorLabel)
		return isCheck;
	}

	render() {
		const { t } = this.props;

		return (
			<div className="modal_overlay" style={{ display: this.props.adapterSetting.modalVisible ? 'block' : 'none' }}>
				<div className="modal_dialog" style={{ display: this.props.adapterSetting.modalVisible ? 'block' : 'none' }}>
					<div className="dialog" style={{ width: "656px", marginLeft: "-328px" }}>
						<div className="dialog_tl">{t('as.text.label.title')}
							<div className="btn_close" onClick={this.props.setAdapterSettingModal} />
						</div>
						<div className="dialog_content">
							<div className="section">
								<div className="error" style={{ display: 'block' }}>{t(this.props.adapterSetting.errorLabel.adapter)}</div>
								<div className="item_label">{t('as.text.label.adapter.name')}</div>
								<input type="text" className="item_input" value={this.props.adapterSetting.data.adapter || ''} readOnly disabled />

								<hr className="section_hr" />

								<div className="item_label">{t('as.text.label.adapter.storage')}</div>
								<div className="item_wrap">
									<input type="text" className="item_input" placeholder={t('as.text.label.adapter.storage.placeholder')} value={this.props.adapterSetting.data.storageName || ''} onChange={this.props.setStorageName} />
									<button className="btn_text_b" onClick={this.onClickSaveStorageName}>{t('as.text.label.adapter.save')}</button>
								</div>
								<div className="error" style={{ display: 'block' }}>{t(this.props.adapterSetting.errorLabel.storageName)}</div>

								<hr className="section_hr" />

								<div className="item_label">{t('as.text.label.adapter.param')}</div>
								<div className="item_wrap">
									<input type="text" className="item_input" placeholder={t('as.text.label.adapter.param.placeholder')} value={this.props.adapterSetting.data.paramsName || ''} onChange={this.props.setParamsName} />
									<button className="btn_text_b" onClick={this.onClickSaveParamsName}>{t('as.text.label.adapter.save')}</button>
								</div>
								<div className="error" style={{ display: 'block' }}>{t(this.props.adapterSetting.errorLabel.paramsName)}</div>

								<hr className="section_hr" />

								<div className="item_label">{t('as.text.label.help.bold')}</div>
								<div className="item_wrap root_path" style={{ flexDirection: 'column', gap: 8 }}>
									{this.state.rootList.map((list, i) => (
										<div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
											<input
												type="text"
												className="item_input"
												placeholder={t('as.text.label.adapter.name')}
												value={list.name}
												onChange={e => this.handleRootListChange(i, 'name', e.target.value)}
											/>
											<input
												type="text"
												className="item_input"
												placeholder={t('as.text.label.adapter.value')}
												value={list.path}
												onChange={e => this.handleRootListChange(i, 'path', e.target.value)}
											/>
											<button
												className="btn_text_b"
												onClick={() => this.deleteItem(i)}
												style={{ whiteSpace: 'nowrap' }}
											>
												{t('delete')}
											</button>
										</div>
									))}
									<div style={{ display: 'flex', gap: 8 }}>
										<button className="btn_text_b" onClick={this.addItem}>
											{t('add')}
										</button>
										<button className="btn_text_b" onClick={this.onClickSaveRootPath}>
											{t('as.text.label.adapter.save')}
										</button>
									</div>
								</div>
								<div className="error" style={{ display: 'block' }}>{t(this.props.adapterSetting.errorLabel.rootPath)}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return {
		adapterSetting: reducers.adapter.adapterSetting
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return {
		setErrorLabel: (value) => { dispatch({ type: types.SET_ADAPTER_SETTING_ERRORLABEL, errorLabel: value }) },
		setAdapterSettingModal: () => { dispatch({ type: types.SET_ADAPTER_SETTING_MODAL }) },
		setStorageName: (e) => { dispatch({ type: types.SET_ADAPTER_SETTING_STORAGENAME, storageName: e.target.value }) },
		setParamsName: (e) => { dispatch({ type: types.SET_ADAPTER_SETTING_PARAMSNAME, paramsName: e.target.value }) },
		setRootName: (e) => { dispatch({ type: types.SET_ADAPTER_SETTING_ROOTNAME, rootName: e.target.value }) },
		setRootPath: (e) => { dispatch({ type: types.SET_ADAPTER_SETTING_ROOTPATH, rootPath: e.target.value }) },

		fetchAdapterSetStorage: (adapter, storageName) => { dispatch({ type: types.FETCH_SET_ADAPTER_STORAGE_REQUEST, adapter: adapter, storageName: storageName }) },
		fetchAdapterSetParams: (adapter, paramsName) => { dispatch({ type: types.FETCH_SET_ADAPTER_PARAMS_REQUEST, adapter: adapter, paramsName: paramsName }) },
		fetchAdapterSetRootPath: (adapter, rootName, rootPath) => { dispatch({ type: types.FETCH_SET_ADAPTER_ROOTPATH_REQUEST, adapter: adapter, rootName: rootName, rootPath: rootPath }) },
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AdapterSetting))